/**
 * Retrieves the value of a cookie by its key
 *
 * @param {string} key - The key of the cookie to retrieve
 * @returns {string} The value of the cookie, or an undefined if not found
 */
export const getCookie = (key: string): string | undefined => {
  // Use a RegExp constructor to avoid potential issues with special characters in the key
  const regex = new RegExp(`(^|;)\\s*${key}\\s*=\\s*([^;]+)`)
  const match = document.cookie.match(regex)

  // Use optional chaining to safely retrieve the last match
  return match?.pop()
}

/**
 * Retrieves whether a OneTrust consent category is granted.
 * Reads the OptanonConsent cookie and checks the groups parameter.
 *
 * @param {string} categoryId - The OneTrust category ID to check (e.g., 'C0002' for Analytics)
 * @returns {boolean} True if the category is granted, false otherwise
 */
export const getOneTrustConsent = (categoryId: string): boolean => {
  const cookieValue = getCookie('OptanonConsent')

  if (!cookieValue) {
    return false
  }

  const decoded = decodeURIComponent(cookieValue)
  const params = new URLSearchParams(decoded)
  const groups = params.get('groups')

  if (!groups) {
    return false
  }

  const group = groups.split(',').find((entry) => entry.split(':')[0] === categoryId)
  return group?.split(':')[1] === '1'
}
